if (document.querySelector('.block-images')) {
    document.addEventListener('DOMContentLoaded', () => {
        const imageBlocks = document.querySelectorAll('.block-images');
        
        imageBlocks.forEach(block => {
            const images = block.querySelectorAll('.block-images-wrapper');
            const count = images.length;
            
            // Удаляем существующие классы
            block.classList.remove('images-1', 'images-2', 'images-3');
            
            // Добавляем нужный класс
            if (count === 1) {
                block.classList.add('images-1');
            } else if (count === 2) {
                block.classList.add('images-2');
            } else if (count >= 3) {
                block.classList.add('images-3');
            }
        });
    });
}